<template>
    <div class="presence-channel-users">
        <slot :users="users" :names="names" :error="error"></slot>
    </div>
</template>

<script>
export default {
    name: 'PresenceChannelUsers',

    props: {
        channel: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            users: [],
            error: null,
        };
    },

    mounted() {
        Echo.join(this.channel)
            .here((users) => {
                this.users = users;
            })
            .joining((user) => {
                this.users.push(user);
            })
            .leaving((user) => {
                this.users.splice(this.users.indexOf(user), 1);
            })
            .error((error) => {
                console.error(error);
                this.error = error;
            });
    },

    beforeDestroy() {
        Echo.leave(this.channel);
    },

    computed: {
        names() {
            return this.users.map((user) => user.name).join(', ')
        },
    },
}
</script>
